import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import style from './WorkOrders.module.css';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import TextButtonWithDocumentation from '../../../documentation/TextButtonDocumentation';
import WorkOrdersDoc from '../../../documentation/WorkOrderDocumentation.jsx';
import InfoIconComponent from '../InfoIcon';
import NumberInputWithUnit from '../../../../../atomic/inputs/numberInputWithUnit/NumberInputWithUnit';
import CheckBox from '../../../../../atomic/formElements/checkBox/CheckBox';
import { Body3 } from '../../../../../atomic/text/Text';

const WorkOrders = ({ top, dispatchTop }) => {
  const {
    workOrders,
    workOrdersOnEntry,
    workOrdersOnExit,
    pctBetweenBidAsk,
    pctIncreasePerOrderAttempt,
    getAwayOffsetPct,
    useDifferentWorkOrderFieldsOnExit,
    getAwayOffsetPctOnExit,
    pctBetweenBidAskOnExit,
    pctIncreasePerOrderAttemptOnExit,
    useDifferentWorkOrderFieldsOnTarget,
    getAwayOffsetPctOnTarget,
    pctBetweenBidAskOnTarget,
    pctIncreasePerOrderAttemptOnTarget,
  } = top;
  //pctIncrease
  const [pctIncreasePerOrderAttemptTxt, setPctIncreasePerOrderAttemptTxt] =
    useState('0');
  //pctBetweenBidAsk
  const [pctBetweenBidAskTxt, setPctBetweenBidAskTxt] = useState('0');
  //offSetPct
  const [getAwayOffsetPctTxt, setGetAwayOffsetPctTxt] = useState('0');
  //pctIncreaseOnExit
  const [
    pctIncreasePerOrderAttemptOnExitTxt,
    setPctIncreasePerOrderAttemptOnExitTxt,
  ] = useState('0');
  //pctbetweenBidAskOnExit
  const [pctBetweenBidAskOnExitTxt, setPctBetweenBidAskOnExitTxt] =
    useState('0');
  //offsetPctOnExit
  const [getAwayOffsetPctOnExitTxt, setGetAwayOffsetPctOnExitTxt] =
    useState('0');
  const [
    pctIncreasePerOrderAttemptOnTargetTxt,
    setPctIncreasePerOrderAttemptOnTargetTxt,
  ] = useState('0');
  //pctbetweenBidAskOnTarget
  const [pctBetweenBidAskOnTargetTxt, setPctBetweenBidAskOnTargetTxt] =
    useState('0');
  //offsetPctOnTarget
  const [getAwayOffsetPctOnTargetTxt, setGetAwayOffsetPctOnTargetTxt] =
    useState('0');

  useEffect(() => {
    //on entry
    setPctBetweenBidAskTxt(pctBetweenBidAsk * 100 + '');
    setPctIncreasePerOrderAttemptTxt(pctIncreasePerOrderAttempt * 100 + '');
    setGetAwayOffsetPctTxt(getAwayOffsetPct * 100 + '');
    //on exit
    setPctBetweenBidAskOnExitTxt(pctBetweenBidAskOnExit * 100 + '');
    setPctIncreasePerOrderAttemptOnExitTxt(
      pctIncreasePerOrderAttemptOnExit * 100 + ''
    );
    setGetAwayOffsetPctOnExitTxt(getAwayOffsetPctOnExit * 100 + '');

    setPctBetweenBidAskOnTargetTxt(pctBetweenBidAskOnTarget * 100 + '');
    setPctIncreasePerOrderAttemptOnTargetTxt(
      pctIncreasePerOrderAttemptOnTarget * 100 + ''
    );
    setGetAwayOffsetPctOnTargetTxt(getAwayOffsetPctOnTarget * 100 + '');
  }, [
    getAwayOffsetPct,
    pctBetweenBidAsk,
    pctIncreasePerOrderAttempt,
    useDifferentWorkOrderFieldsOnExit,
    getAwayOffsetPctOnExit,
    pctBetweenBidAskOnExit,
    useDifferentWorkOrderFieldsOnTarget,
    getAwayOffsetPctOnTarget,
    pctBetweenBidAskOnTarget,
  ]);
  return (
    <div className={style.container}>
      <div className={style.checkboxAndTooltip}>
        <CheckBox
          margin="0 3px 0 0"
          checked={workOrders}
          onChange={(checked) => dispatchTop({ workOrders: checked })}
        >
          Work Orders
        </CheckBox>
        <span>
          <InfoIconComponent docs={WorkOrdersDoc} />
        </span>
      </div>
      <div className={style.conditional}>
        <div className={style.checkBoxes}>
          <CheckBox
            margin="0 3px 0 0"
            disabled={!workOrders}
            checked={workOrdersOnEntry}
            onChange={(checked) => dispatchTop({ workOrdersOnEntry: checked })}
          >
            On Entry
          </CheckBox>
          <CheckBox
            margin="0 0 0 3px"
            disabled={!workOrders}
            checked={workOrdersOnExit}
            onChange={(checked) => dispatchTop({ workOrdersOnExit: checked })}
          >
            On Exit
          </CheckBox>
          <CheckBox
            margin="0 0 0 3px"
            disabled={!workOrders || !workOrdersOnExit}
            checked={useDifferentWorkOrderFieldsOnExit}
            onChange={(checked) =>
              dispatchTop({ useDifferentWorkOrderFieldsOnExit: checked })
            }
          >
            Decouple Exit
          </CheckBox>
          <CheckBox
            margin="0 0 0 3px"
            disabled={!workOrders || !workOrdersOnExit}
            checked={useDifferentWorkOrderFieldsOnTarget}
            onChange={(checked) =>
              dispatchTop({ useDifferentWorkOrderFieldsOnTarget: checked })
            }
          >
            Decouple Target
          </CheckBox>
        </div>
        {useDifferentWorkOrderFieldsOnExit ||
        useDifferentWorkOrderFieldsOnTarget ? (
            <Body3 fontWeight={700}>On Entry</Body3>
          ) : null}
        <div className={style.inputs}>
          <div className={style.labelAndInput}>
            <Body3>Work Order Limit</Body3>
            <NumberInputWithUnit
              value={getAwayOffsetPctTxt}
              setValue={setGetAwayOffsetPctTxt}
              direction="right"
              width="80px"
              type="number"
              disabled={!workOrders}
              onBlur={(value) =>
                dispatchTop({
                  getAwayOffsetPct: value !== '' ? parseFloat(value) / 100 : 0,
                })
              }
            >
              %
            </NumberInputWithUnit>
          </div>
          <div className={style.labelAndInput}>
            <Body3>% Between Bid/Ask</Body3>
            <NumberInputWithUnit
              value={pctBetweenBidAskTxt}
              setValue={setPctBetweenBidAskTxt}
              direction="right"
              width="80px"
              type="number"
              disabled={!workOrders}
              onBlur={(value) =>
                dispatchTop({
                  pctBetweenBidAsk: value !== '' ? parseFloat(value) / 100 : 0,
                })
              }
            >
              %
            </NumberInputWithUnit>
          </div>
          <div className={style.labelAndInput}>
            <Body3>% Increase/Attempt</Body3>
            <NumberInputWithUnit
              value={pctIncreasePerOrderAttemptTxt}
              setValue={setPctIncreasePerOrderAttemptTxt}
              direction="right"
              width="80px"
              type="number"
              disabled={!workOrders}
              onBlur={(value) =>
                dispatchTop({
                  pctIncreasePerOrderAttempt:
                    value !== '' ? parseFloat(value) / 100 : 0,
                })
              }
            >
              %
            </NumberInputWithUnit>
          </div>
        </div>
        {useDifferentWorkOrderFieldsOnExit ? (
          <>
            <Body3 fontWeight={700}>
              {useDifferentWorkOrderFieldsOnTarget ? 'On Stop' : 'On Exit'}
            </Body3>
            <div className={style.inputs}>
              <div className={style.labelAndInput}>
                <Body3>Work Order Limit</Body3>
                <NumberInputWithUnit
                  value={getAwayOffsetPctOnExitTxt}
                  setValue={setGetAwayOffsetPctOnExitTxt}
                  direction="right"
                  width="80px"
                  type="number"
                  disabled={!workOrders}
                  onBlur={(value) =>
                    dispatchTop({
                      getAwayOffsetPctOnExit:
                        value !== '' ? parseFloat(value) / 100 : 0,
                    })
                  }
                >
                  %
                </NumberInputWithUnit>
              </div>
              <div className={style.labelAndInput}>
                <Body3>% Between Bid/Ask</Body3>
                <NumberInputWithUnit
                  value={pctBetweenBidAskOnExitTxt}
                  setValue={setPctBetweenBidAskOnExitTxt}
                  direction="right"
                  width="80px"
                  type="number"
                  disabled={!workOrders}
                  onBlur={(value) =>
                    dispatchTop({
                      pctBetweenBidAskOnExit:
                        value !== '' ? parseFloat(value) / 100 : 0,
                    })
                  }
                >
                  %
                </NumberInputWithUnit>
              </div>
              <div className={style.labelAndInput}>
                <Body3>% Increase/Attempt</Body3>
                <NumberInputWithUnit
                  value={pctIncreasePerOrderAttemptOnExitTxt}
                  setValue={setPctIncreasePerOrderAttemptOnExitTxt}
                  direction="right"
                  width="80px"
                  type="number"
                  disabled={!workOrders}
                  onBlur={(value) =>
                    dispatchTop({
                      pctIncreasePerOrderAttemptOnExit:
                        value !== '' ? parseFloat(value) / 100 : 0,
                    })
                  }
                >
                  %
                </NumberInputWithUnit>
              </div>
            </div>
          </>
        ) : null}
        {useDifferentWorkOrderFieldsOnTarget ? (
          <>
            <Body3 fontWeight={700}>On Target</Body3>
            <div className={style.inputs}>
              <div className={style.labelAndInput}>
                <Body3>Work Order Limit</Body3>
                <NumberInputWithUnit
                  value={getAwayOffsetPctOnTargetTxt}
                  setValue={setGetAwayOffsetPctOnTargetTxt}
                  direction="right"
                  width="80px"
                  type="number"
                  disabled={!workOrders}
                  onBlur={(value) =>
                    dispatchTop({
                      getAwayOffsetPctOnTarget:
                        value !== '' ? parseFloat(value) / 100 : 0,
                    })
                  }
                >
                  %
                </NumberInputWithUnit>
              </div>
              <div className={style.labelAndInput}>
                <Body3>% Between Bid/Ask</Body3>
                <NumberInputWithUnit
                  value={pctBetweenBidAskOnTargetTxt}
                  setValue={setPctBetweenBidAskOnTargetTxt}
                  direction="right"
                  width="80px"
                  type="number"
                  disabled={!workOrders}
                  onBlur={(value) =>
                    dispatchTop({
                      pctBetweenBidAskOnTarget:
                        value !== '' ? parseFloat(value) / 100 : 0,
                    })
                  }
                >
                  %
                </NumberInputWithUnit>
              </div>
              <div className={style.labelAndInput}>
                <Body3>% Increase/Attempt</Body3>
                <NumberInputWithUnit
                  value={pctIncreasePerOrderAttemptOnTargetTxt}
                  setValue={setPctIncreasePerOrderAttemptOnTargetTxt}
                  direction="right"
                  width="80px"
                  type="number"
                  disabled={!workOrders}
                  onBlur={(value) =>
                    dispatchTop({
                      pctIncreasePerOrderAttemptOnTarget:
                        value !== '' ? parseFloat(value) / 100 : 0,
                    })
                  }
                >
                  %
                </NumberInputWithUnit>
              </div>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

WorkOrders.propTypes = {
  dispatchTop: PropTypes.func,
  top: PropTypes.shape({
    getAwayOffsetPct: PropTypes.number,
    getAwayOffsetPctOnExit: PropTypes.number,
    getAwayOffsetPctOnTarget: PropTypes.number,
    pctBetweenBidAsk: PropTypes.number,
    pctBetweenBidAskOnExit: PropTypes.number,
    pctBetweenBidAskOnTarget: PropTypes.number,
    pctIncreasePerOrderAttempt: PropTypes.number,
    pctIncreasePerOrderAttemptOnExit: PropTypes.number,
    pctIncreasePerOrderAttemptOnTarget: PropTypes.number,
    useDifferentWorkOrderFieldsOnExit: PropTypes.any,
    useDifferentWorkOrderFieldsOnTarget: PropTypes.any,
    workOrders: PropTypes.any,
    workOrdersOnEntry: PropTypes.any,
    workOrdersOnExit: PropTypes.any,
  }),
};

export const WorkOrdersQuickTrade = ({
  workOrder,
  setWorkOrder,
  pctIncreasePerOrderAttempt,
  setPctIncreasePerOrderAttempt,
  pctBetweenBidAsk,
  setPctBetweenBidAsk,
  getAwayOffsetPct,
  setGetAwayOffsetPct,
}) => {
  // const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const [pctIncreasePerOrderAttemptTxt, setPctIncreasePerOrderAttemptTxt] =
    useState('0');
  const [pctBetweenBidAskTxt, setPctBetweenBidAskTxt] = useState('0');
  const [getAwayOffsetPctTxt, setGetAwayOffsetPctTxt] = useState('0');

  useEffect(() => {
    setPctBetweenBidAskTxt(pctBetweenBidAsk * 100 + '');
    setPctIncreasePerOrderAttemptTxt(pctIncreasePerOrderAttempt * 100 + '');
    setGetAwayOffsetPctTxt(getAwayOffsetPct * 100 + '');
  }, [getAwayOffsetPct, pctBetweenBidAsk, pctIncreasePerOrderAttempt]);

  const isAlreadyWorkOrder = workOrder;

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <div>
      <FormControlLabel
        value="top"
        control={
          <Checkbox
            color="primary"
            checked={isAlreadyWorkOrder}
            onChange={(ev) => setWorkOrder(ev.target.checked)}
          />
        }
        label={
          <TextButtonWithDocumentation label="work order" doc={WorkOrdersDoc} />
        }
        labelPlacement="start"
      />
      {workOrder ? (
        <div>
          <TextField
            type="text"
            label={
              <Typography style={{ fontSize: 12 }}>
                <b>work order limit</b>
              </Typography>
            }
            value={getAwayOffsetPctTxt}
            onBlur={(ev) =>
              setGetAwayOffsetPct(
                ev.target.value !== '' ? parseFloat(ev.target.value) / 100 : 0
              )
            }
            onChange={(ev) => setGetAwayOffsetPctTxt(ev.target.value)}
            InputProps={{ endAdornment: '%' }}
            //  required
          />
          <TextField
            type="text"
            label={
              <Typography style={{ fontSize: 12 }}>
                <b>pct btwn bid ask</b>
              </Typography>
            }
            value={pctBetweenBidAskTxt}
            onChange={(ev) => setPctBetweenBidAskTxt(ev.target.value)}
            onBlur={(ev) =>
              setPctBetweenBidAsk(
                ev.target.value !== '' ? parseFloat(ev.target.value) / 100 : 0
              )
            }
            InputProps={{ endAdornment: '%' }}
            //  required
          />
          <TextField
            type="text"
            label={
              <Typography style={{ fontSize: 12 }}>
                <b>pct increase per order attempt</b>
              </Typography>
            }
            value={pctIncreasePerOrderAttemptTxt}
            onChange={(ev) => setPctIncreasePerOrderAttemptTxt(ev.target.value)}
            onBlur={(ev) =>
              setPctIncreasePerOrderAttempt(
                ev.target.value !== '' ? parseFloat(ev.target.value) / 100 : 0
              )
            }
            InputProps={{ endAdornment: '%' }}
            //  required
          />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default WorkOrders;
